import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfFocusScoreGoalService } from '../../../core/application/services/goals/get-self-focus-score-goal.service';
import { SelfFocusScoreGoalEntity } from '../../../core/domain/entities/goals/score-goals/self-focus-score-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfFocusScoreGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfFocusScoreGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfFocusScoreGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
